export const STORE_ADMIN_DETAIL = 'STORE_ADMIN_DETAIL';
